import api from "../services/api";

// Fetch transactions with optional dynamic filtering
export const fetchTransactions = async (
  filterField = null,
  filterValue = null,
  page = 1,
  size = 50
) => {
  try {
    const params = { page, size };

    // Add filter parameters only if both are provided
    if (filterField && filterValue) {
      params.filter_field = filterField;
      params.filter_value = filterValue;
    }

    const response = await api.get("/transaction-management/payments/", {
      params,
    });

    if (response.status === 200) {
      return response.data.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error fetching transactions:", error.message || error);
    const errorMessage =
      error.response?.data?.detail || error.message || "Failed to fetch transactions";
    return { error: errorMessage };
  }
};

// Trigger refund for a transaction by PayGate transaction ID
export const refundTransaction = async (paygateTransactionId) => {
  try {
    const response = await api.post(
      "/transaction-management/payments/refund",
      null,
      {
        params: { paygate_transaction_id: paygateTransactionId },
      }
    );

    if (response.status === 200) {
      return response.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error processing refund:", error.message || error);
    const errorMessage =
      error.response?.data?.detail || error.message || "Failed to process refund";
    return { error: errorMessage };
  }
};
